module.exports = __webpack_public_path__ + "static/media/payload.a64401f0.mft";